import { Component, h, Prop } from '@stencil/core';
import { VariationItemWithControls } from '../../../redux/types';

@Component({
  tag: 'rentware-variation-selection-cart-template',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareVariationSelectionCartTemplate {
  @Prop() variationItems: VariationItemWithControls[];

  render() {
    return (
      <div class="CartWrapper">
        {this.variationItems.map((item: VariationItemWithControls) => {
          return (
            <div class="ListItem">
              <div class="TextContainer">{item.name}</div>

              <rentware-amount-control controlValues={item.controlValues} />
            </div>
          );
        })}
      </div>
    );
  }
}
